import { Editor } from 'tinymce';

// Use the native Range API with childNode offsets in the parent so the
// cursor lands outside the span. TinyMCE's select()+collapse() normalises
// back into the span's text node, causing an infinite intercept loop.
export function moveCursorRelativeToSpan(ed: Editor, dynamicElementContainer: Node, afterSpan: boolean) {
	const parent = dynamicElementContainer.parentNode as Node;
	const spanIdx = Array.from(parent.childNodes).findIndex((n) => n === dynamicElementContainer);
	const rng = ed.dom.createRng();
	rng.setStart(parent, afterSpan ? spanIdx + 1 : spanIdx);
	rng.collapse(true);
	ed.selection.setRng(rng);
}
